module.exports = __webpack_public_path__ + "assets/webgl/skybox.jpg.pvr.ca960064.ktx";